/**
 * UGC report reasons — the single source of truth shared by the web report
 * dialog. These MUST stay in lockstep with the `content_reports.reason` CHECK
 * constraint and the admin queue's REASON_LABELS
 * (src/app/admin/moderation/reports/page.tsx). If you add a reason, add it in
 * all three places + the DB migration.
 */
export const REPORT_REASONS = ['inappropriate', 'spam', 'harassment', 'off_topic', 'other'] as const
export type ReportReason = (typeof REPORT_REASONS)[number]

/** i18n key (under the `moderation` namespace) for each reason label. */
export const REPORT_REASON_KEY: Record<ReportReason, string> = {
  inappropriate: 'reasonInappropriate',
  spam: 'reasonSpam',
  harassment: 'reasonHarassment',
  off_topic: 'reasonOffTopic',
  other: 'reasonOther',
}

/**
 * The UGC content types a member can report from the web. A subset of the
 * `content_reports.content_type` CHECK (which also allows first-party content +
 * contest submissions the member UI never files). All three flow into
 * Admin → Moderation → Reports.
 */
export type ReportContentType = 'comment' | 'community_post' | 'community_comment'
